import { useEffect, type FC, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { UiGrid } from '@/lib/ui';
import Ticket from './Ticket';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { type TicketType } from '@/api/constant';
import QueryContainer from '@/base/QueryContainer/QueryContainer';
import { useTenantApi } from '@/account/hook/useTenantApi';
import { type TicketListData, loadTicketListByAttendeeCategory, ticketListQueryKey, type Registration } from '@/api/registration';
import { useShoppingCart } from '@/registration/hook/useShoppingCart';

export interface TicketListProps {
  ticketType: TicketType
  onEmpty?: () => void
  registration: Registration
  isUpsell?: boolean
}

const TicketList: FC<TicketListProps> = ({ ticketType, onEmpty, registration, isUpsell }) => {
  const { eventId } = useRegisterRoute();
  const { createTenantApiRequest, isLoading: isApiPreparing } = useTenantApi();
  const attendeeCategoryId = registration?.attendeeCategoryId;
  const { hasTicket } = useShoppingCart(eventId);
  // const isInCart = useMemo(() => {
  //   return hasTicket(ticket.id);
  // }, [
  //   hasTicket,
  // ]);

  const ticketQuery = useQuery<TicketListData, Error>({
    queryKey: [ticketListQueryKey, { eventId, ticketType, attendeeCategoryId }],
    queryFn: async () => {
      return (
        await loadTicketListByAttendeeCategory(createTenantApiRequest)({
          eventId,
          attendeeCategoryId,
          ticketType,
          registrationId: registration.id
        })).items;
    },
    enabled: !!attendeeCategoryId && !isApiPreparing
  });

  return (
    <QueryContainer query={ticketQuery}>
      {tickets => {
        return (
          <UiGrid
            templateColumns={{ base: '1fr', lg: '1fr 1fr' }}
            gap={8}
          >
            {tickets.map((ticket) => {
              return (
                <Ticket
                  key={ticket.id}
                  ticket={ticket}
                  isUpsell={isUpsell}
                  isAdded={hasTicket(ticket)}
                />
              );
            })}
          </UiGrid>
        );
      }}
    </QueryContainer>
  );
};

export default TicketList;
